import React from "react";
import { renderToString } from "react-dom/server";
import "./index.scss";

const Toast = () => {};

let rootNode;

const map: any = {};
let id = 0;

const hide = (node: Element) => {
  rootNode.removeChild(node);
};

const show = (children: string, waitMS = 2000) => {
  if (!rootNode) {
    rootNode = document.createElement("div");
    rootNode.classList.add("toast-container");
    document.body.appendChild(rootNode);
  }

  const content = document.createElement("div");
  content.classList.add("toast-content");
  content.textContent = children;
  rootNode.appendChild(content);

  const key = id++;
  const timer = setTimeout(() => {
    hide(content);
    delete map[key];
  }, waitMS);
  map[key] = {
    clear: () => {
      clearTimeout(timer);
      hide(content);
      delete map[key];
    },
  };
};

Toast.show = show;
Toast.hide = hide;
Toast.hideAll = () => {
  Object.keys(map).forEach(key => map[key]?.clear?.());
};

/**
 * @description 只展示一个Toast
 */
Toast.show1 = (children: string, waitMS = 2000) => {
  Toast.hideAll();
  Toast.show(children, waitMS);
};

/**
 * @description 显示组件
 */
const showComponent = (
  component: React.ReactElement<any, string | React.JSXElementConstructor<any>>,
  params?: Parameters<typeof show>[1],
) => {
  show(renderToString(component), params);
};
Toast.showComponent = showComponent;
export default Toast;
